import * as styles from './styles.css';
import DisclaimerTrigger from './disclaimer-trigger';
interface ILinks {
  href: string;
  text: string;
}

interface IFooterBottomLineLinksProps {
  links?: ILinks[];
  onClickDisclaimer: () => void;
  disclaimerActive: boolean;
}

const LINKS: ILinks[] = [
  { href: '/privacy', text: 'Privacy Policy ' },
  { href: '/terms-of-use', text: 'Terms of Use' },
  { href: '/careers', text: 'Careers' },
  { href: '/accessibility', text: 'Accessibility' },
  { href: 'https://www.nerdy.com/', text: 'a Nerdy company' },
];

const FooterBottomLineLinks = ({
  links = LINKS,
  onClickDisclaimer,
  disclaimerActive,
}: IFooterBottomLineLinksProps) => {
  return (
    <div className={styles.footerBottomLineLinks}>
      <DisclaimerTrigger onClick={onClickDisclaimer} disclaimerActive={disclaimerActive} />
      {links.map(({ href, text }) => (
        <a className={styles.link} href={href} key={href} rel="noopener noreferrer" target="_blank">
          {text}
        </a>
      ))}
    </div>
  );
};

export default FooterBottomLineLinks;
